import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EventItemCustomFieldAvailValueCreditType } from '../../../../shared/custom-reg-fields/event-item-custom-field-avail-value-credit-type.model';
import { DtoBase, ObjectStateEnum } from '../../../../../shared/model/index';
import { CE_CreditType } from '../../../../../config/ceu/ce-credit-type.model';

@Component({
  selector: 'wl-registration-field-drop-down-value-credit-type-list',
  templateUrl: 'event-settings-registration-drop-down-value-credit-type-list.component.html',
  styleUrls: ['event-settings-registration-drop-down-value-credit-type-list.component.css'],
    standalone: false
})
export class EventRegistrationFieldDropdownValueCreditTypeListComponent implements OnInit {
  @Input() availValueCreditTypes: Array<EventItemCustomFieldAvailValueCreditType> = [];

  public _objectStateEnum: any = ObjectStateEnum;

  /**
   * constructor
   */
  public constructor() {
    this.availValueCreditTypes = [];
  }

  /**
   * my initter
   */
  ngOnInit() {}

  /**
   * triggered by add button click
   */
  public handleAddClick(): void {
    let newEventItemCreditType = new EventItemCustomFieldAvailValueCreditType();
    this.availValueCreditTypes.push(newEventItemCreditType);
  }

  /**
   * triggered by remove button click
   * @param availValueCreditType
   */
  public handleRemoveClick(availValueCreditType: EventItemCustomFieldAvailValueCreditType) {
    if (!availValueCreditType) return;

    // if already added to db, then mark for delete, else remove from list
    if (availValueCreditType.Id > 0) {
      availValueCreditType.ObjectState = ObjectStateEnum.Deleted;
    } else {
      let index = this.availValueCreditTypes.indexOf(availValueCreditType);
      if (index >= 0) this.availValueCreditTypes.splice(index, 1);
    }
  }

  /**
   * triggered by unremove button click
   * @param availValueCreditType
   */
  public handleUnRemoveClick(availValueCreditType: EventItemCustomFieldAvailValueCreditType) {
    if (!availValueCreditType) return;

    availValueCreditType.ObjectState = ObjectStateEnum.Unchanged;
  }
}
